import script from "./DashboardIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&setup=true&lang=js"

import "./DashboardIndex.vue?vue&type=style&index=0&id=0732356e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0732356e"]])

export default __exports__